module.exports = __webpack_public_path__ + "assets/fa-folder-open.eb98ae93.svg";